import React, {
    useContext
} from 'react';

import ExportContext from '../../../contexts/exportContext.js';

import {
    useCurationConfigValue,
    useGetFocusedInstanceIdState
} from '../../../hooks/widgetConfiguration.js';

import ExportDropdown from '../../../components/ExportDropdown.jsx';

import RIQButton from '../../../components/RIQButton.jsx';
import RIQDropdown from '../../../components/RIQDropdown.jsx';
import MetricLoadingView from '../../../components/MetricLoadingView.jsx';
import SearchBar from './SearchBar.jsx';


export default function Toolbar() {
    const isExporting = Boolean(useContext(ExportContext));
    const companyId = useCurationConfigValue('companyId');
    const landscapeId = useCurationConfigValue('landscapeId');
    const onlyInstanceId = useCurationConfigValue('onlyInstanceId');
    const searchTerm = useCurationConfigValue('searchTerm');
    const [showOnlyInstanceId, setFocusedInstanceId] = useGetFocusedInstanceIdState() || [onlyInstanceId, _.noop];
    const timePeriod = useCurationConfigValue(null, 'timePeriod');

    if (isExporting) {
        return;
    }

    function onBackButtonClick() {
        setFocusedInstanceId(undefined);
    }

    const filters = {
        company: {
            onlyCompanyIds: [companyId],
            landscapeId: landscapeId
        },
        publicPost: {
            searchTerm: searchTerm
        },
        timePeriod: {
            startDate: timePeriod.mainPeriodStart,
            endDate: timePeriod.mainPeriodEnd
        }
    };

    const metricRequests = {
        totalActivity: {
            dataSourceId: RivalIQ.metrics.new.enums.DataSourceIds.TIKTOK_PRIVATE_POST_DATA,
            dimensions: [],
            measure: 'distinctCount(post_id)',
            filters: filters
        },
        postsTypes: {
            dataSourceId: RivalIQ.metrics.new.enums.DataSourceIds.TIKTOK_PRIVATE_POST_DATA,
            dimensions: ['post_id'],
            measure: 'media_type',
            filters: filters
        }
    };

    function postsTypesReducer(memo, row) {
        memo[`All Media`] = (memo[`All Media`] || 0) + 1;
        const postType = _.last(row);
        memo[postType] = (memo[postType] || 0) + 1;
        return memo;
    }

    return (
        <MetricLoadingView metricRequests={metricRequests}>
            {
                (metricResults) => {

                    const postsCount = _.last(_.last(metricResults.totalActivity.data));
                    const postsTypes = metricResults.postsTypes.data.reduce(postsTypesReducer, {
                        'All Media': 0
                    });
                    const dropdownOptions = _.map(postsTypes, function mapPostsTypes(count, postType) {
                        return {
                            id: postType,
                            name: `${postType} (${count})`,
                            selected: postType === 'All Media'
                        };
                    });

                    return (
                        <div className='tlw-mb-10'>
                            <div className='tlw-flex tlw-w-full tlw-flex-col tlw-gap-8 sm_tlw-flex-row'>
                                <div className='tlw-flex tlw-w-full tlw-justify-between'>
                                    {showOnlyInstanceId &&
                                        <RIQButton
                                            className='tlw-mr-8 tlw-self-start tlw-p-3'
                                            onClick={onBackButtonClick}>
                                            <span className='fa fa-chevron-left'/>
                                        </RIQButton>
                                    }
                                    <div className='tlw-flex tlw-w-full tlw-gap-8'>
                                        <SearchBar
                                            postsCount={postsCount}
                                        />
                                        <RIQDropdown
                                            dropdownOptions={dropdownOptions}
                                            instanceId={showOnlyInstanceId}
                                            onItemSelected={_.noop}
                                            showSelectedInTitle={true}
                                            title='Post Type'
                                            variant='toolbar'
                                        />
                                    </div>
                                    <div className='tlw-flex tlw-justify-end'>
                                        <ExportDropdown
                                            variant='large'
                                            instanceId={showOnlyInstanceId}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        </MetricLoadingView>
    );
}
